module.exports = __webpack_public_path__ + "static/media/claudia-lange.b3f42bf6.jpg";